export default () => ({
  trigger: {
    name: 'order_block.select_available_stores_pickup',
    params: {},
  },
  config: {
    event: {
      name: 'select_pickup',
      params: {
        sub_feature: 'pick_up_locations',
      },
    },
  },
});
